<template>
  <div class="outer-box" v-loading="lockStatus" element-loading-text="数据加载中......" element-loading-spinner="el-icon-loading">
    <el-row :gutter="10">
      <el-col :span="5">
        <corner-box class="select-box box-element">
          <div class="select-con">
            <span>分部：</span>
            <el-select v-model="area" @change="getCategory">
              <el-option v-for="item in areaList" :label="item.divisionName" :value="item.id" :key="item.id"></el-option>
            </el-select>
          </div>
          <div class="select-con">
            <span>能源类型：</span>
            <el-select v-model="energyType"  @change="getCategory">
              <el-option v-for="item in energyTypeList" :label="item.name" :value="item" :key="item.name"></el-option>
            </el-select>
          </div>
          <div class="select-con">
            <span>能源分项：</span>
            <el-select v-model="energyCategory" @change="getBuildings">
              <el-option v-for="item in energyCategoryList" :label="item.categoryName" :value="item" :key="item.categoryName"></el-option>
            </el-select>
          </div>
          <div class="select-con">
            <span>建筑筛选：</span>
            <el-tree
            class="tree-box"
              :data="treeList"
              node-key="id"
              ref="tree"
              show-checkbox
              :props="defaultProps"
              :default-checked-keys="defaultCheckedTreeKey">
            </el-tree>
          </div>
          <div class="sumbit-box">
            <button class="fun" @click="reset" v-if="false">重置</button>
          </div>
        </corner-box>
      </el-col>
      <el-col :span="19">
        <corner-box class="box-element">
          <div class="time-box">
            <div class="left-span fl">
              <span>时间周期：</span>
              <el-radio-group v-model="timeType" @change="changePeriod">
                <el-radio-button label="year">年</el-radio-button>
                <el-radio-button label="month">月</el-radio-button>
                <el-radio-button label="day">日</el-radio-button>
              </el-radio-group>
              <span>选择日期：</span>
              <el-date-picker
                class="select-date"
                :type="dateType"
                :value-format="dateFormat"
                placeholder="请选择开始时间"
                v-model="startDate"
                :picker-options="defaultSdate"
                :key="'start'+startDate"
                :clearable='false'
              ></el-date-picker>
              <span> — </span>
              <el-date-picker
                class="select-date"
                :type="dateType"
                :value-format="dateFormat"
                placeholder="请选择结束时间"
                v-model="endDate"
                :picker-options="defaultEdate"
                :key="'end'+endDate"
                :clearable='false'
              ></el-date-picker>
              <button class="fun" @click="query(true)">查询</button>
            </div>
            <div class="fr">
              <button class="fun" @click="download()">下载</button>
              <button class="fun" @click="print()">打印</button>
            </div>
          </div>
          <div class="con-box">
            <div class="title-box">{{titleName}}排名</div>
            <el-table class="table-box hasBorder" :data="tableData">
              <el-table-column  prop="ranking" label="排名" width="60"></el-table-column>
              <el-table-column  prop="division" label="区域名称" width="100"></el-table-column>
              <el-table-column  prop="buildingName" label="建筑名称"></el-table-column>
              <el-table-column  prop="merchantName" label="单位/商户名称"></el-table-column>
              <el-table-column  prop="buildingArea" label="建筑总面积（m³）"></el-table-column>
              <el-table-column  prop="airConditionerArea" label="空调总面积（m³）"></el-table-column>
              <el-table-column  prop="peopleNumber" label="使用人数（人）"></el-table-column>
              <el-table-column  prop="totalEnergy" :label="'总能耗'+tableHeadName" sortable></el-table-column>
              <el-table-column  prop="perCapitaEnergy" :label="'人均能耗'+tableHeadName" width="140" sortable></el-table-column>
              <el-table-column  prop="unitAreaEnergy" :label="'单位面积能耗'+tableHeadName" width="160" sortable></el-table-column>
            </el-table>
            <el-pagination
              background
              :page-sizes="[20, 30, 40, 50]"
              :page-size="pageSize"
              :current-page.sync="currentPage"
              @current-change="query(false)"
              layout="total,prev,pager,next,jumper"
              :total="totalInfo">
          </el-pagination>

          </div>

        </corner-box>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getLastDay,getNowFormatDate } from "../../assets/js/tools/time.js"
import {getSession, setSession} from '../../assets/js/tools/instruments'
import cornerBox from "../../components/cornerBox";

export default {
  name: "ECRanking",
  components:{
    cornerBox
  },
  data(){
    return{
      lockStatus: false,
      energyType:{ value: "0", name: "全部" },
      energyTypeList: [],
      energyCategory: { value: '0', categoryName: '全部' },
      energyCategoryList: [],
      timeType: 'year',
      dateType: "year",
      dateFormat: "yyyy",
      startDate: getNowFormatDate("year").toString(),
      endDate: getNowFormatDate("year").toString(),
      area: '1',
      areaList: [],
      treeList: [],
      defaultProps: {
        children: 'child',
        label: 'categoryName'
      },
      defaultCheckedTreeKey: [],
      titleName: getNowFormatDate("year").toString() + '年总能耗',
      tableData: [],
      tableHeadName: '(tce)',
      totalInfo: 0,
      pageSize: 20,
      currentPage: 1,
      defaultSdate:{
        disabledDate:(time)=>{
          return time.getTime() >= new Date(this.endDate).getTime() || time.getTime()<new Date(JSON.parse(getSession("projectInfo")).projectStartTime).getTime()
        }
      },
      defaultEdate:{
        disabledDate:(time)=>{
          return time.getTime() <= new Date(this.startDate).getTime() || time.getTime()>new Date().getTime()
        }
      }
    }
  },
  mounted() {
    this.initdata()
  },
  methods:{
    changePeriod(val) {
      this.startDate = '';
      this.endDate = '';
      if(val == 'day'){
        this.dateType = 'date'
        this.dateFormat = 'yyyy-MM-dd'
        this.startDate = getLastDay("month")
        this.endDate = getNowFormatDate()
      }else if(val == 'month'){
        this.dateType = 'month'
        this.dateFormat = 'yyyy-MM'
        this.startDate = getNowFormatDate("year") + "-" + "01"
        this.endDate = getNowFormatDate("month")
      }else{
        this.dateType = 'year'
        this.dateFormat = 'yyyy'
        this.startDate = getNowFormatDate("year").toString()
        this.endDate = getNowFormatDate("year").toString()
     }
    },
    getTreeChild(data){
      let result = [];
      let rr = function (arr){
        arr.forEach(function (item){
          result.push(item.id);
        })
      }
      rr(data)
      return result
    },
    initdata() {
      this.lockStatus = true;
      let param = [];
      param.divisionId = "0";
      this.$get('ecranking/pageinitialization',param).then((response)=>{
        this.lockStatus = false;
        this.areaList = response.division;
        this.energyTypeList = response.energyType;
        this.energyCategoryList = [{categoryName:'全部',value:'0'}].concat(response.categoryList);
        this.treeList = response.buildingList;
        this.defaultCheckedTreeKey = this.getTreeChild(response.buildingList);
        this.tableData = response.energyRanking;
        for( let i in this.tableData) {
          this.tableData[i].merchantName = "-";
          this.tableData[i].totalEnergy *= 1;
          if ( this.tableData[i].perCapitaEnergy == "-"){
            this.tableData[i].perCapitaEnergy = 0;
          } else {
            this.tableData[i].perCapitaEnergy *= 1;
          }
          this.tableData[i].unitAreaEnergy *= 1;
        }
        this.totalInfo = response.total;
      }),
      (err) => {
        console.log(err);
        this.lockStatus = true;
      }
    },
    getCategory() {
      this.lockStatus = true;
      this.$get('ecranking/getelecclassifylist',[this.area , this.energyType.value]).then((response)=>{
        this.lockStatus = false;
        if(response.length > 0){
          this.energyCategoryList = [{value:'0',categoryName:'全部'}].concat(response);
          this.energyCategory = {value:'0',categoryName:'全部'};
          this.getBuildings();
        }else{
          this.energyCategoryList = [];
          this.energyCategory = {};
          this.treeList = [];
        }
      }),
      (err) => {
        console.log(err);
        this.lockStatus = true;
      }
    },
    getBuildings() {
      this.lockStatus = true;
      if( this.energyCategory.value ) {
        this.$get('ecranking/getbuildinglistbycategorytypelist',[this.area , this.energyType.value , this.energyCategory.value]).then((response)=>{
          this.lockStatus = false;
          this.treeList = response;
        }),
        (err) => {
          console.log(err);
          this.lockStatus = true;
        }
      } else {
        this.lockStatus = false;
        this.$message.error("请选择能源分项！");
      }
    },
    reset() {
      this.energyType = { value: "0", name: "全部" };
      this.energyCategory = { value: '0', categoryName: '全部' };
      this.area = '1';
      this.timeType = "year";
      this.changePeriod("year");
      this.initdata();
    },
    setParam() {
      let params = [];
      params.divisionId = this.area;
      params.energyTypeId = this.energyType.value;
      params.categoryListId = this.energyCategory.value;
      params.period = this.timeType;
      params.startDate = this.startDate;
      params.endDate = this.endDate;
      params.pageNum = this.currentPage;
      params.pageSize = this.pageSize;
      params.buildingId = this.$refs.tree.getCheckedKeys().join(',');
      return params;
    },
    query(resPage) {
      if(resPage) {
        this.currentPage = 1;
      }
      this.lockStatus = true;
      if( this.energyCategory.value ){
        if( this.$refs.tree.getCheckedKeys().join(',') ){
          this.$get('ecranking/getenergyrankingdate',this.setParam()).then((response)=>{
            this.lockStatus = false;
            this.tableData = response.getEnergyRankingData;
            for( let i in this.tableData) {
              this.tableData[i].merchantName = "-";
              this.tableData[i].totalEnergy *= 1;
              if ( this.tableData[i].perCapitaEnergy == "-"){
                this.tableData[i].perCapitaEnergy = 0;
              } else {
                this.tableData[i].perCapitaEnergy *= 1;
              }
              this.tableData[i].unitAreaEnergy *= 1;
            }
            this.totalInfo = response.total;
            if( this.startDate === this.endDate ){
              this.titleName = this.formatDate(this.endDate)
            } else {
              this.titleName = this.formatDate(this.startDate) + '——' + this.formatDate(this.endDate);
            }
            if( this.energyType.value === '0' ) {
              if( this.energyCategory.value === '0' ) {
                this.titleName += '总能耗';
              } else {
                this.titleName += '总能耗(' + this.energyCategory.categoryName + ')';
              }
            } else {
              if ( this.energyCategory.value === '0' ){
                this.titleName += this.energyType.name + '能耗';
              } else {
                this.titleName += this.energyType.name + '(' + this.energyCategory.categoryName + ')能耗';
              }
            }
            if( this.energyType.value ==="0"){
              this.tableHeadName = '(tce)'
            } else if ( this.energyType.value ==="1" ){
              this.tableHeadName = '(kW·h)'
            } else if ( this.energyType.value ==="2" ){
              this.tableHeadName = '(m³)'
            } else {
              this.tableHeadName = '(t)'
            }
          }),
          (err) => {
            console.log(err);
            this.lockStatus = true;
          }
        } else {
          this.lockStatus = false;
          this.$message.error("请选择相应建筑！");
        }
      } else {
        this.lockStatus = false;
        this.$message.error("请选择能源分项！");
      }
    },
    formatDate(date) {
      let dateForm = '';
      if ( date.length === 4 ){
        dateForm = date + '年';
      } else if ( date.length === 7 ){
        dateForm = date.replace('-','年') + '月';
      } else {
        dateForm = date.split('-')[0] + '年' + date.split('-')[1] + '月' + date.split('-')[2] + '日' 
      }
      return dateForm;
    },
    download(){
      let parameter = this.setParam();
      let parameterStr = ""; 
      for (let i in parameter) {
        parameterStr += parameter[i] + "/";
      }
      parameterStr = parameterStr.slice(0, parameterStr.length - 1);
      let a = document.createElement("a");
      a.setAttribute(
        "href",
        this.rootUrl + "ecranking/downloadreport/" + parameterStr
      );
      a.setAttribute("download", "");
      document.body.appendChild(a);
      a.click();
      a.remove();
    },
    print() {
      setSession('ECRankingData', [this.area,this.energyType.value,this.energyCategory.value,this.timeType,this.startDate,this.endDate,this.currentPage,this.pageSize,this.$refs.tree.getCheckedKeys().join(',')]);
      let routeData = this.$router.resolve({
        name: 'printECRanking',
        path: '/printECRanking'
      });
      window.open(routeData.href,'_blank')
    }
  }
}
</script>

<style scoped lang="scss">
.outer-box{
  color: $light;
  padding: 10px 5px;
  .select-box{
    position: relative;
    height: 755px;
    .select-con{
      padding-top: 20px;
      span{
        display: inline-block;
        width: 80px;
        text-align: right;
      }
      .tree-box {
        margin: 20px 0 0 40px;
      }
    }
    .sumbit-box{
      position: absolute;
      left: 85px;
      bottom: 30px;
      button {
        margin-left: 15px;
      }
    }
  }
  .con-box{
    height: 670px;
    padding: 10px 10px 30px;
    margin-bottom: 10px;
    div{
      width: 100%;
      span{
        font-size: 14px;
        line-height: 30px;
      }
      .el-button{
        margin-left: 10px;
      }
    }
    .title-box {
      font-size: 16px;
    }
    .table-box{
      margin: 10px 0 15px;
    }
  }
  .time-box {
    overflow: hidden;
    padding: 15px 20px;
    margin-bottom: 10px;
    .left-span {
      button {
        margin-left: 10px;
      }
    }
  }
}
@media screen and (width:3440px) and (height: 1440px )   {
  .outer-box{
    .select-box{
      height: 1200px;
    }
    .con-box{
      height: 1115px;
    }
  }
}
</style>
